import { render, staticRenderFns } from "./KCharts.vue?vue&type=template&id=3484576c&scoped=true"
import script from "./KCharts.vue?vue&type=script&lang=js"
export * from "./KCharts.vue?vue&type=script&lang=js"
import style0 from "./KCharts.vue?vue&type=style&index=0&id=3484576c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3484576c",
  null
  
)

export default component.exports